import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

import { Storage } from '@ionic/storage';

import { Insomnia } from '@ionic-native/insomnia';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  user_api_hash = undefined;
  currentPage: any = 'ListVeiculosPage';
  rootPage: any = 'ListVeiculosPage';

  pages: Array<{ icon: string, title: string, component: any }>;

  constructor(
    public events: Events,
    private insomnia: Insomnia,
    public storage: Storage,
    private platform: Platform,
    public alertCtrl: AlertController,
    statusBar: StatusBar
  ) {


    platform.ready().then(() => {
      if (platform.is('ios')) {
        statusBar.styleBlackTranslucent();
      }
      else {
        statusBar.styleLightContent();
        //statusBar.hide();              
      }
      statusBar.backgroundColorByHexString('#222222');
      //splashScreen.hide();
    });
    //Manter tela ligada
    this.insomnia.keepAwake();
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts